module.exports = __webpack_public_path__ + "media/images/linkedin-1a9291b1.png";